import { Injectable } from '@angular/core';
import { UserService } from '@app/api/user.service';
import { User } from '@shared/models/user/user.model';
import { BehaviorSubject, Observable, shareReplay, tap } from 'rxjs';
import { map } from 'rxjs/operators';
import { BrandType } from '@ess-front/shared';

@Injectable({
  providedIn: 'root',
})
export class UserDomainService {
  private readonly _user$: BehaviorSubject<User | undefined | null> = new BehaviorSubject<User | undefined | null>(
    undefined,
  );
  constructor(private userService: UserService) {}

  getCurrentUser$(): Observable<User | undefined | null> {
    return this._user$.asObservable();
  }

  getUser$(): Observable<User> {
    return this.userService.getUser$().pipe(tap(user => this._user$.next(user)));
  }

  getUserByHash$(hash: string): Observable<User> {
    return this.userService.getUserByHash$(hash);
  }

  getUserHash$(): Observable<string | null> {
    return this.getCurrentUser$().pipe(map(user => (user ? user.hash : null)));
  }

  clearCurrentUser(): void {
    this._user$.next(null);
  }

  patchUser$(user: Partial<User>): Observable<User> {
    return this.userService
      .patchUser$(user)
      .pipe(tap(user => this._user$.next({ ...this._user$.getValue(), ...user })));
  }

  public isUserLatam$(): Observable<boolean> {
    return this.getCurrentUser$().pipe(
      map(user => user?.brand === BrandType.LATAM),
      shareReplay(1),
    );
  }
}
